<template>
  <ModuleSection title="U盾证书更新">
    <el-form
      ref="form"
      label-width="180px"
      :model="formData">
      <el-row :gutter="40">
        <!-- 汇款人姓名 -->
        <el-col
          :span="24"
          v-for="item in formItemList"
          :key="item.prop">
          <el-form-item
            :label="$t(item.label) + ':'"
            v-show="item.type">
            <template>
              <div :class="['item', {active : item.prop === 'customerNameCN'}]">
                {{formData[item.prop]}}{{item.subfix || ''}}
              </div>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="button-group">
      <el-button
        class="button"
        @click="handleDown">
        {{$t('证书下载')}}
      </el-button>
    </div>
  </ModuleSection>
</template>
<script>
import { mapState } from 'vuex'
import { certUpdate } from '../api'
export default {
  data () {
    return {
      formItemList: [
        { label: '企业名称', prop: 'customerNameCN', type: true },
        { label: '用户名称', prop: 'userName', type: true },
        { label: 'USBKEY序号', prop: 'userId', type: true },
        { label: '证书驱动(CSP)', prop: 'toAcc', type: false }
      ],
      formData: {}
    }
  },
  computed: {
    ...mapState('home', [
      'sessionInfo',
      'sessionData'
    ])
  },
  mounted () {
    this.formData = {
      customerId: this.sessionInfo.session_customerId,
      userId: this.sessionInfo.session_userId,
      customerNameCN: this.sessionData.session_customerNameEN, // session_customerNameEN   customerName
      userName: this.sessionInfo.userName
    }
    this.getInfo()
  },
  methods: {
    getInfo () {
      certUpdate().then(res => {
        if (res) {
          this.formData = {
            ...this.formData,
            USBKeyType: res.USBKeyType,
            USBKey: res.USBKey,
            beginDate: this.$_format.parseDate(res.beginDate, 'yyyymmddhhmiss').format('yyyy-mm-dd'),
            endDate: this.$_format.parseDate(res.endDate, 'yyyymmddhhmiss').format('yyyy-mm-dd'),
            femAmount: res.femAmount
          }
        }
      })
    },
    handleDown () {
      // TODO: 证书下载
      // FIXME: 跳转之后的逻辑在旧企业网银环境下是无法正常进行的 需要产品进行重新规划设计
    }
  }
}
</script>
<style lang="less" scoped>
.item {
  width: 500px;
  height: 46px;
  border-radius: 4px;
  border: 1px solid #e6e9f4;
  padding: 0 16px;
  line-height: 46px;
  &.active {
    color: #C0C4CC;
    background: #f6f7fc;
  }
}
.button-group {
  .button {
    min-width: 140px;
  }
}

</style>
